var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-status"},[_c('v-chip',{staticClass:"chip__width",attrs:{"color":_vm.payload.color,"text-color":_vm.payload.textColor,"small":""}},[_vm._v(" "+_vm._s(_vm.payload.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }